import { fetchApi } from 'api/index'
import { StorefrontService } from 'components/storefront/StoreFront.constants'

export const fixApiRename = (serviceName: string) => {
  if (serviceName === StorefrontService.featuredPhotos) {
    return 'featured-photos'
  }
  return serviceName
}

/**
 * @param {String} orderId
 * @param {Number} userId
 * @param {Number} giftImageId
 * @param {String} text
 * @param {Boolean} hidden
 * @param {String} sourceScreen {@enum profile,rating,messenger} Откуда был подарен гифт?
 */
export const placeGiftOrderApi = (
  orderId: number,
  userId: number,
  giftImageId: number,
  text: string,
  hidden: boolean,
  sourceScreen = 'rating'
) =>
  fetchApi('/sales/orders/gifts/placeOrder', {
    method: 'POST',
    body: JSON.stringify({
      orderId,
      userId,
      giftImageId,
      text,
      hidden,
      sourceScreen,
    }),
  })

export const placeTopUpOrderApi = (orderId, coins) =>
  fetchApi('/sales/orders/topup/placeOrder', {
    method: 'POST',
    body: JSON.stringify({
      orderId,
      coins,
    }),
  })

export const placePhotoLineOrderApi = (orderId, photoId, text = '', photos) =>
  fetchApi('/sales/orders/photoline/placeOrder', {
    method: 'POST',
    body: JSON.stringify({
      orderId,
      photoId,
      text,
      photos,
    }),
  })

export const placeFeaturedPhotosOrderApi = (orderId, photoId, impressions) =>
  fetchApi('/sales/orders/featured-photos/placeOrder', {
    method: 'POST',
    body: JSON.stringify({
      orderId,
      photoId,
      impressions,
    }),
  })
